import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from '@/lib/auth/session';

/**
 * 로그인 문지기.
 *
 * <p><b>이것은 인가가 아니다.</b> 무엇을 볼 수 있는지는 서버가 매 요청 판정한다(권한 키 `safe`).
 * 여기서 하는 일은 로그인하지 않은 사람을 관문(`/`)으로 보내는 UX 뿐이다.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const session = useSession();

  if (session.isPending) {
    return <div className="p-6 text-ui-sm" style={{ color: 'var(--text-muted)' }}>불러오는 중입니다</div>;
  }

  if (session.isError || !session.data.authenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  return <>{children}</>;
}
